import { motion } from "framer-motion";
import { PHASES } from "../../data/site";

export const PhaseSteps = ({ light = false }) => (
  <ol data-testid="phase-steps" className="relative grid gap-0 md:grid-cols-5">
    <motion.span
      className="pointer-events-none absolute left-0 top-[27px] hidden h-px w-full origin-left bg-gold md:block"
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
    />
    {PHASES.map((p, i) => (
      <motion.li
        key={p.n}
        data-testid={`phase-step-${p.n}`}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, delay: 0.15 + i * 0.12 }}
        className={`relative flex gap-5 border-l pb-10 pl-6 md:block md:border-l-0 md:pb-0 md:pl-0 md:pr-6 ${light ? "border-white/15" : "border-navy/15"}`}
      >
        <span className={`relative z-10 -ml-[49px] flex h-14 w-14 shrink-0 items-center justify-center rounded-full border text-sm font-bold md:ml-0 ${light ? "border-gold bg-navy text-gold" : "border-gold bg-white text-navy"}`}>
          {p.n}
        </span>
        <div className="md:mt-7">
          <h3 className={`text-lg font-semibold leading-snug ${light ? "text-white" : "text-navy"}`}>{p.title}</h3>
          <p className={`mt-3 text-sm leading-relaxed ${light ? "text-white/75" : "text-slate2"}`}>{p.text}</p>
        </div>
      </motion.li>
    ))}
  </ol>
);
